<template>
  <div class="chat-visa-page">
    <chat-visa-component
      ref="chatVisaComponent"
      :hooks="hooks"
      :options="options"
    >
      <div slot="page-body" slot-scope="props">
        <div class="container-sm">
          <guide-module
            v-if="layout.isShowGuide"
            :show-close="!!props.chatList.length"
            @close="layout.isShowGuide = false"
            @send-question="onSendQuestion"
          ></guide-module>
        </div>
    
      </div>
      <template  slot="footer-handle-left">
        <div class="handler-btn" v-show="!layout.isShowGuide" @click="handleShowGuide">了解签问</div>
      </template>
    </chat-visa-component>
  </div>
</template>

<script>
import chatVisaComponent from './components/chat-visa-component.vue';
import sensorsdata from 'sa-sdk-javascript';
import GuideModule from './components/guide-module.vue';

export default {
  components: {
    chatVisaComponent,
    GuideModule,
  },
  data() {
    return {
      layout: {
        isShowGuide: true, // 是否显示引导模块
      },
      hooks: {
        getChatList: (chatList) => {
          // 存在列表，则隐藏引导模块
          if (chatList.length) {
            this.layout.isShowGuide = false;
          }
        },
        onSend: () => {
          this.layout.isShowGuide = false;
        },
      },
    };
  },
  computed: {
    options() {
      return {
        hidePageBody: this.layout.isShowGuide,
        bodyWidth: '920px',
      };
    },
  },
  beforeRouteEnter(to, from, next) {
    sensorsdata.track('qw_view', {
      source: !from.name ? '直接访问' : to.query.page_from,
    });
    next();
  },
  created() {},
  methods: {
    onSendQuestion(data) {
      this.$refs.chatVisaComponent.onSendQuestion(data);
    },
    handleShowGuide() {
      sensorsdata.track('qw_guide_click', {});
      this.layout.isShowGuide = true;
    },
  },
};
</script>

<style lang="less" scoped>
.chat-visa-page{
  width: 100%;
  height: calc(~'100vh - 68px');
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/ChatVisa.vue